import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createSessionCookieRequest = {};
var _rawHttpResponse = { body: 'BYTES' };
function resolveWixIamCookieV1CookieServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/cookie',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/iam/cookie',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/iam/cookie',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/iam/cookie',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/iam/cookie',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function createSessionCookie(payload) {
    var _a = serializer(_createSessionCookieRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __createSessionCookie(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.cookie.v1.cookie',
            method: 'POST',
            methodFqn: 'wix.iam.cookie.v1.CookieService.CreateSessionCookie',
            url: resolveWixIamCookieV1CookieServiceUrl({
                protoPath: '/v1/createSessionCookie',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixIamCookieV1CookieServiceUrl({
                        protoPath: '/v1/createSessionCookie',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __createSessionCookie.fromReq = fromReq;
    __createSessionCookie.__isAmbassador = true;
    return __createSessionCookie;
}
//# sourceMappingURL=http.impl.js.map